/**
 * Money / currency formatting helpers — UI display only.
 *
 * Universal rule (see ~/.claude/.../memory/feedback_currency_formatting.md):
 * every dollar value shown to a user is formatted with thousands separators
 * and exactly 2 decimals. Excel/CSV exports stay raw numeric so the
 * spreadsheet can apply its own formatting and SUM() / sort behavior
 * works correctly.
 *
 * Use formatMoney() for plain values: $11,343.21
 * Use formatMoneySigned() if you want a leading '-' on negatives instead
 *   of the default '$-1,234.56' rendering.
 */

export function formatMoney(n) {
  const num = Number(n);
  if (!Number.isFinite(num)) return '$0.00';
  return `$${num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatMoneySigned(n) {
  const num = Number(n);
  if (!Number.isFinite(num)) return '$0.00';
  if (num < 0) return `-${formatMoney(-num)}`;
  return formatMoney(num);
}
